import { UserManager, WebStorageStateStore, User } from 'oidc-client';
import {CONFIG} from '@/config';

export default class AuthService {
    userManager;

    constructor() {
      const {protocol, hostname} = location;
      let port = '';

      if(CONFIG.NODE_ENV === 'development' && hostname === 'localhost')
        port = ':4200';

      const settings = {
        userStore: new WebStorageStateStore({ store: window.localStorage }),
        authority: CONFIG.URL.IDENTITY_SERVER,
        client_id: CONFIG.CLIENT_ID,
        redirect_uri: `${protocol}//${hostname}${port}/callback.html`,
        response_type: 'code',
        scope: 'openid profile Neocom.Neogig.Api Neocom.Neodash.Api Neocom.ControlPanel.Api',
        post_logout_redirect_uri: `${protocol}//${hostname}${port}`,
      };

      const params = new Proxy(new URLSearchParams(window.location.search), {
          get: (searchParams, prop) => searchParams.get(String(prop)),
      });

      if (params['language']) {
        window.localStorage.setItem('language', params['language']);
      }

      this.userManager = new UserManager(settings);
    }

    getUser() {
        return this.userManager.getUser();
    }

    login() {
        return this.userManager.signinRedirect();
    }

    logout() {
        return this.userManager.signoutRedirect();
    }

     async getAccessToken() {
        return await this.userManager.getUser().then((user) => {
            return user != null ? user.access_token : this.login();
        });
    }

    getAccessTokenHeader() {
        return {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
        };
    }

    redirectIfNotAuthenticated() {
        if(!this.isAuthenticated())
            this.login();
    }

    revokeAccessToken() {
        return this.userManager.revokeAccessToken();
    }

    isAuthenticated() {
        return this.userManager.getUser()
          .then((user) => {
              if(user !== null) {
                  sessionStorage.setItem('username', user.profile.given_name);
                  sessionStorage.setItem('token', user.access_token);
                  sessionStorage.setItem('tokenType', user.token_type);
                  sessionStorage.setItem('client', user.profile.IdClient);
                  sessionStorage.setItem('vehicle', user.profile.IdVehicleType);
                  sessionStorage.setItem('expires', new Date(user.expires_at).toDateString());
                  let tokenExpired = this.isTokenExpired(user);

                  return true;
              }
            return false;
        });
    }

    isTokenExpired(user: any) {
        const currentDate = new Date();
        const tokenExpireDate = new Date(user.expires_at);

        return currentDate > tokenExpireDate;
    }
}

